import Webcam from 'react-webcam';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { AppButton, Flex } from '@/components';
import { DataMoonHttp } from '@/services';
import { makeError } from '@/utils';
import { useUserContext } from '@/context';

export interface ConfirmImageProps {
  hide: () => void;
  webcam: React.MutableRefObject<Webcam>;
}

const ConfirmImage: React.FC<ConfirmImageProps> = ({
  hide,
  webcam,
}) => {
  const [src, setSrc] = useState(null);
  const [t] = useTranslation(['common', 'face']);
  const [uploading, setUploading] = useState(false);
  const [imageBlob, setImageBlob] = useState(null);
  const { profile } = useUserContext();

  const getCanvas = useCallback(() => {
    if (!webcam.current) return;
    const canvas = webcam.current.getCanvas();
    return canvas;
  }, [webcam.current]);

  useEffect(() => {
    const canvas = getCanvas();
    if (!canvas) return;
    const imageSrc = canvas.toDataURL('image/png', 1);
    canvas.toBlob(blob => setImageBlob(blob), 'image/png', 1);
    setSrc(imageSrc);
  }, []);

  const handleUpload = useCallback(async () => {
    setUploading(true);
    const userId = profile?.username;
    try {
      const response = await DataMoonHttp.enroll(userId, imageBlob);
      if (!response.data.success) {
        hide();
        makeError('noFace');
        return;
      }
      hide();
      message.success({ content: t('face:messages.success-face-enrollment') });
    }
    catch (e) {
      console.error(e);
    }
    finally {
      setUploading(false);
    }
  }, [profile, imageBlob, t]);

  return (
    <Flex direction="column">
      <img className="rounded-xl" src={src} style={{ objectFit: 'cover', objectPosition: 'center' }} />
      <AppButton loading={uploading} disabled={uploading} onClick={handleUpload} appVariant="submit">
        {uploading ? t('common:labels.sending') : t('common:labels.confirm-submit')}
      </AppButton>
    </Flex>
  );
};

export default ConfirmImage;
